import React from 'react';

// Create a context for the current theme (with null as the default).
const ThemeContext = React.createContext(null);

export default ThemeContext;
